var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: "Grupos de produtos", loading: _vm.loading } },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "router-link",
              {
                staticClass: "button is-primary",
                attrs: { to: { name: "product-group-manage" } }
              },
              [_vm._v("\n        Adicionar grupo de produtos\n      ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("sc-grid", {
        attrs: {
          data: _vm.productGroups,
          total: _vm.productGroups.length,
          "default-sort-column": "id",
          "default-sort-direction": "desc",
          "default-filters": _vm.defaultFilters,
          "has-backend-sorting": false
        },
        on: { submit: _vm.getProductGroups },
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function(ref) {
              var filters = ref.filters
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column is-narrow" },
                    [
                      _c(
                        "sc-field",
                        { attrs: { label: "Pesquisa por Sku" } },
                        [
                          _c("sc-input", {
                            attrs: { placeholder: "Digite um SKU" },
                            model: {
                              value: filters.sku,
                              callback: function($$v) {
                                _vm.$set(filters, "sku", $$v)
                              },
                              expression: "filters.sku"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "table-columns",
            fn: function(ref) {
              var props = ref.props
              return [
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "id",
                      label: "ID",
                      width: "80",
                      sortable: ""
                    }
                  },
                  [_vm._v("\n        " + _vm._s(props.row.id) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "name",
                      label: "Nome",
                      centered: false,
                      sortable: ""
                    }
                  },
                  [_vm._v("\n        " + _vm._s(props.row.name) + "\n      ")]
                ),
                _vm._v(" "),
                _c("sc-table-column", { attrs: { label: "Sku" } }, [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.transformSkus(props.row)) +
                        "\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  { attrs: { label: "Ações", width: "150" } },
                  [
                    _c(
                      "div",
                      { staticClass: "buttons has-addons" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "button is-primary",
                            attrs: {
                              to: {
                                name: "product-group-manage",
                                params: { id: props.row.id }
                              }
                            }
                          },
                          [_vm._v("\n            Editar\n          ")]
                        ),
                        _vm._v(" "),
                        _c("sc-button", {
                          attrs: { theme: "danger", text: "Deletar" },
                          on: {
                            click: function($event) {
                              _vm.deleteGroup(props.row)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2fb890a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2fb890a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/product-groups/PageProductGroups.vue
// module id = null
// module chunks = 